import React from 'react';
import { Provider } from 'react-redux';
import ThemeProvider from 'theme/index';
import store from 'redux_config/store';

function withRedux(Component) {
  return (props) => (
    <Provider store={store}>
      <ThemeProvider>
        <Component {...props}/>
      </ThemeProvider>
    </Provider>
  );
}

export default withRedux;
